import {  DeferObservable  } from './DeferObservable';

export const defer = DeferObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/defer.ts